import { render } from "./FruitsPicking.vue?vue&type=template&id=b8dc80a2&scoped=true"
import script from "./FruitsPicking.vue?vue&type=script&lang=js"
export * from "./FruitsPicking.vue?vue&type=script&lang=js"

import "./FruitsPicking.vue?vue&type=style&index=0&id=b8dc80a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dc80a2"]])

export default __exports__